/*
 * File: IsOverriddenFilter.tsx
 * Project: beaker
 * -----
 * Last Modified: 24 May 2022 5:57:41 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { LabeledValueType, RawValueType } from 'rc-tree-select/lib/TreeSelect';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setIsWebOrderDimensionPermission } from 'redux/services/julia/productCatalogParams';
import { ReduxState, useAppDispatch } from 'redux/store';
import { FancySelect } from '../Inputs';

export const IsDimPermissionsOverageFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();
  const { isWebOrderDimPermissionsOverageDefault } = useSelector((state: ReduxState) => state.juliaProductCatalogParams);

  /* ******************** Functions ******************** */
  const handleChange = (value: RawValueType | LabeledValueType): void => {
    dispatch(setIsWebOrderDimensionPermission(value === undefined ? undefined : value === 'TRUE' ? true : false));
  };

  /********** cleanup ***********/
  useEffect(() => {
    return (): void => {
      dispatch(setIsWebOrderDimensionPermission(undefined));
    };
  }, [dispatch]);

  return (
    <FancySelect
      placeholder="Is Dim Perm"
      onChange={handleChange}
      value={isWebOrderDimPermissionsOverageDefault !== undefined ? (isWebOrderDimPermissionsOverageDefault ? 'TRUE' : 'FALSE') : undefined}
      options={[
        { value: 'TRUE', label: 'TRUE' },
        { value: 'FALSE', label: 'FALSE' }
      ]}
    />
  );
};
